/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EntityOrigin } from './EntityOrigin';
import {
    instanceOfEntityOrigin,
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * @type DefinitionParameterDtoOrigin
 * 
 * @export
 */
export type DefinitionParameterDtoOrigin = EntityOrigin;


export function DefinitionParameterDtoOriginFromJSON(json: any): DefinitionParameterDtoOrigin {
    return DefinitionParameterDtoOriginFromJSONTyped(json, false);
}

export function DefinitionParameterDtoOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionParameterDtoOrigin {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EntityOriginFromJSONTyped(json, true) };
    return  EntityOriginFromJSONTyped(json, true);
}

export function DefinitionParameterDtoOriginToJSON(value?: DefinitionParameterDtoOrigin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEntityOrigin(value)) {
        return EntityOriginToJSON(value as EntityOrigin);
    }

    return {};
}

/**
 * Check if a given object implements the DefinitionParameterDtoOrigin interface.
 */
export function instanceOfDefinitionParameterDtoOrigin(value: any): value is DefinitionParameterDtoOrigin {
    if (instanceOfEntityOrigin(value)) return true;
    return false;
}

